import React from "react";
import AppRoutes from "./Router";
import { Provider } from "react-redux";
import { store } from "./store/configureStore";
import Theme from "./config/CustomThemeProvider";
import EnvironmentBadge from "./components/shared/EnvironmentBadge";

export default function App() {
  return (
    <Provider store={store}>
      <Theme>
        <AppRoutes />
        <EnvironmentBadge />
      </Theme>
    </Provider>
  );
}
